export const ThumbnailDimensions = {
  small: {
    widthInPx: 100,
    heightInPx: 100,
  } as FileDimension,
  medium: {
    widthInPx: 140,
    heightInPx: 140,
  } as FileDimension,
  large: {
    widthInPx: 283,
    heightInPx: 138,
  } as FileDimension,
};
export enum ThumbnailSizes {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export type FileDimension = {
  widthInPx: number;
  heightInPx: number;
};
